import React from "react";
import "./WelocateBedroomFilter.css";

const OPTIONS = [1, 2];

const WelocateUxExperienceFilter = ({ selected, onSelect }) => (
  <div className="wl-bedroom-filter">
    {OPTIONS.map((value) => {
      const isSelected = selected === value;
      return (
        <button
          key={value}
          className={`wl-bedroom-filter__option${isSelected ? " wl-bedroom-filter__option--selected" : ""}`}
          onClick={() => onSelect(value)}
        >
          {value}
        </button>
      );
    })}
  </div>
);

export default WelocateUxExperienceFilter;
